import axios from 'axios'
import { useAuthStore } from '../../stores/authStore'
import { friendlyApiError } from '../utils/apiError'

// If BACKEND_API_URL is set, use it directly (dev server / production).
// If empty, use /api so the Vite dev proxy handles it (local Docker).
const BASE_URL = import.meta.env.BACKEND_API_URL
  ? `${import.meta.env.BACKEND_API_URL}/api`
  : '/api'

const PUBLIC_ROUTES = [
  '/auth/login',
  '/auth/register',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/setup-password',
  '/admin/settings/site-info',
]

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
})

apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

apiClient.interceptors.response.use(
  (response) => {
    // Auto-unwrap DataResponse envelope: { data: T } → T
    // Only unwraps when "data" is the sole key (leaves PaginatedResponse intact).
    const d = response.data
    if (d !== null && typeof d === 'object' && Object.keys(d).length === 1 && 'data' in d) {
      response.data = d.data
    }
    return response
  },
  (error: unknown) => {
    if (axios.isAxiosError(error)) {
      const isPublicRoute = PUBLIC_ROUTES.some((r) => error.config?.url?.includes(r))
      if (error.response?.status === 401 && !isPublicRoute) {
        useAuthStore.getState().logout()
        window.location.href = '/signin'
      }
      return Promise.reject(new Error(friendlyApiError(error)))
    }
    return Promise.reject(error)
  }
)

export default apiClient
